import { ProductsTemplate } from "@/components/Templates";
import { useProductsPage } from "@/hooks/useProductsPage";

export function ProductsPage() {
  const productsPage = useProductsPage();

  return <ProductsTemplate {...productsPage} />;
}
